module.exports = __webpack_public_path__ + "img/header-bank-square-top.812bc133.svg";